import styled, { css } from 'styled-components';

export const PromoHighlightedWrapper = styled.div`
  margin-bottom: 0.5em;
  margin-bottom: 0.5em;
`;

export const PromoHighlightedRow = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 0.55em;  
  width: 100%;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    
  }
  border-bottom: 1px solid transparent;
  &:hover {
    background: ${props => props.theme.colors.hoverColor};
    border-bottom: 1px solid ${props => props.theme.colors.hoverBorderColor};
  };
  &.no-event{
    pointer-events: none;
    .icon-matchcenter-right-arrow{
      display: none;
    }
  };
  min-height: 55px;
`;

export const PromoImageWrapper = styled.div`
  width: 90px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 25%;
  }
`;

export const PromoImage = styled.img`
  height: 55px;
  object-fit: cover;
  image-rendering: optimizeSpeed;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: optimize-contrast;
  -ms-interpolation-mode: nearest-neighbor;
`;

export const PromoTitle = styled.div`
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size: 1.125em;
  width: calc(100% - 90px);
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: 75%;
  }
  text-align: left;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 1em;
  }
  ${props => (props.hasImage) && css` 
    padding-left: 6px;
  `};
`;

export const PromoSubTitle = styled.span`
  color: ${props => props.theme.colors.linkColor};
  font-family: ${props => props.theme.fontSets.narrowRegular};
`;
